<template>
  <div class="container page">
      <van-nav-bar :title="$t('setting.title')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
      <div class="items">
        <div class="item van-hairline--bottom" @click="toInfomation()">
          <div class="left">{{$t('setting.basicInfo')}}</div>
          <van-icon name="arrow" />
        </div>
        <div class="item van-hairline--bottom" @click="toLoginPassword()">
          <div class="left">{{$t('setting.loginPassword')}}</div>
          <van-icon name="arrow" />
        </div>
        <div class="item van-hairline--bottom" @click="toPayPassword()">
          <div class="left">{{$t('setting.fundPassword')}}</div>
          <div class="right">
            <span class="desc">{{this.userInfo.paypassword}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
      <van-button class="sign-out" type="primary" size="normal" @click="loginout()">{{$t('setting.logout')}}</van-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toPayPassword(){
      this.$router.push({path:'/SetPayPassword'});
    },
    toLoginPassword(){
      this.$router.push({path:'/SetLoginPassword'});
    },
    toInfomation(){
      this.$router.push({path:'/Infomation'});
    },
    loginout(){
        localStorage.clear()
        this.$router.push({path:'/Mine'});
    },
    toServicePage(){
      this.$router.push("ServicePage");
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          if(res.data.paypassword){
            this.userInfo.paypassword = this.$t('setting.payPasswordHasSet');
          }else {
            this.userInfo.paypassword = this.$t('setting.payPasswordNotSet');
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .items{
  background-color: #fff;
  font-size: 30px;
  color: #000;
  padding: 0 25px;
}
.container .items .item{
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 10px;
}
.container .items .van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.container .sign-out{
  margin: 500px 20px 0;
  height: 100px;
  line-height: 100px;
  border-radius: 50px;
  color: #fff;
  font-size: 40px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      270deg,#e6c3a1,#7e5678);
}
.container  .item .desc{
  font-size: 30px;
  font-weight: 700;
  color: #979799;
}
.container .item .right{
  display: flex;
  flex-direction: row;
  align-items: center;
}

@media (max-width: 430px) {
  .container.page {
    width: 100%;
    min-width: 0;
    min-height: 100svh;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    padding-bottom: max(16px, env(safe-area-inset-bottom));
  }

  .container .nav-bar {
    flex: 0 0 auto;
    height: auto;
    min-height: 56px;
    padding-top: env(safe-area-inset-top);
  }

  .container .nav-bar ::v-deep .van-nav-bar__content {
    min-height: 56px;
  }

  .container .nav-bar ::v-deep .van-nav-bar__title {
    max-width: calc(100% - 96px);
    font-size: 17px;
    line-height: 1.25;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .container .items {
    min-width: 0;
    padding: 0 16px;
    font-size: 16px;
  }

  .container .items .item {
    min-width: 0;
    gap: 12px;
    padding: 18px 0;
  }

  .container .item .left {
    min-width: 0;
    flex: 1 1 52%;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .container .item .right {
    min-width: 0;
    max-width: 48%;
    gap: 5px;
    justify-content: flex-end;
  }

  .container .item .desc {
    min-width: 0;
    font-size: 14px;
    line-height: 1.3;
    text-align: right;
    overflow-wrap: anywhere;
  }

  .container .item .van-icon {
    flex: 0 0 auto;
  }

  .container .sign-out {
    width: calc(100% - 32px);
    min-height: 50px;
    height: auto;
    margin: auto 16px 0;
    padding: 10px 14px;
    border-radius: 25px;
    font-size: 17px;
    line-height: 1.3;
    white-space: normal;
  }
}
</style>
